import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))] focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]",
        secondary:
          "border-transparent bg-[hsl(var(--secondary))] text-[hsl(var(--secondary-foreground))]",
        destructive:
          "border-transparent bg-[hsl(var(--destructive))] text-[hsl(var(--destructive-foreground))]",
        outline: "text-[hsl(var(--foreground))]",
        info: "border-transparent bg-[hsl(var(--info))] text-[hsl(var(--info-foreground))]",
        accent:
          "border-transparent bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]",
        "meta-level":
          "border border-[hsl(var(--status-approved-border))] bg-[hsl(var(--status-approved-bg))] text-[hsl(var(--status-approved-text))]",
        "meta-type":
          "border border-[hsl(var(--status-draft-border))] bg-[hsl(var(--status-draft-bg))] text-[hsl(var(--status-draft-text))]",
        "status-draft":
          "border border-[hsl(var(--status-draft-border))] bg-[hsl(var(--status-draft-bg))] text-[hsl(var(--status-draft-text))] uppercase tracking-wide",
        "status-approved":
          "border border-[hsl(var(--status-approved-border))] bg-[hsl(var(--status-approved-bg))] text-[hsl(var(--status-approved-text))] uppercase tracking-wide",
        "status-inprogress":
          "border border-[hsl(var(--status-inprogress-border))] bg-[hsl(var(--status-inprogress-bg))] text-[hsl(var(--status-inprogress-text))] uppercase tracking-wide",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
